module.exports = __webpack_public_path__ + "media/images/emblems/Blason_commune_CH_Leysin_(Vaud)-c48259e130aa9c7e1acba6026f3bf091.svg";